import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {GeoJSON} from 'react-leaflet';
import {onParkingAreaClick} from '../../actions/parkingArea';
import ParkingAreaMarkersLayer from './ParkingAreaMarkersLayer';
import styles from './../../styles/parkingSpots';
import { anyFilterSet } from './../../utils';

class ParkingSpaces extends Component {

  constructor(props) {
    super(props);
    this.onEachFeature = this.onEachFeature.bind(this);
    this.parkingAreaStyle = this.parkingAreaStyle.bind(this);
  }

  onEachFeature(feature, layer) {
    layer.on({
      click: () => {this.props.onParkingAreaClick(feature);}
    });
  }

  isFilterPresent(spots1, spots2){
    for(let i=0; i < spots1.length; i++){
      if(spots2.indexOf(spots1[i]) !== -1){
        return true;
      }
    }
    return false;
  }

  parkingAreaStyle(feature) {
    const { availableFilteredSpots, areaSpotsMapList, anyFilterSet } = this.props;
    const { name } = feature.properties;
    const spotsUnderArea = areaSpotsMapList[name] || [];

    if(anyFilterSet && spotsUnderArea.length && availableFilteredSpots.length) {
      if(this.isFilterPresent(spotsUnderArea, availableFilteredSpots)) {
        return styles.filteredArea;
      }
    }
    return '';
  }

  render() {
    const { data, showParkingAreaMarker } = this.props;
    return (
      <div>
        <g>
          <GeoJSON key={Math.random()}
                   data={data}
                   onEachFeature={this.onEachFeature}
                   bubblingMouseEvents={false}
                   style={this.parkingAreaStyle}
          />
        </g>
        <g>
          { showParkingAreaMarker && <ParkingAreaMarkersLayer features={data.features} /> }
        </g>
      </div>
    );
  }

}

const mapStateToProps = (state) => (
  {
    parkingLocations: state.geoJsonData.parkingLocations,
    availableFilteredSpots: state.search.availableFilteredSpots,
    areaSpotsMapList: state.session.areaSpotsMapList,
    showParkingAreaMarker: state.parkingSpots.showParkingAreaMarker,
    anyFilterSet: anyFilterSet()
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ onParkingAreaClick }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkingSpaces);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingAreas.js